import { render, staticRenderFns } from "./JobCreate.vue?vue&type=template&id=49b10d49&"
import script from "../../../services/admin/job/job-create.js?vue&type=script&lang=js&"
export * from "../../../services/admin/job/job-create.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports